@use "../../../../../styles/Colors.scss" as Colors;
@use "../../../../../styles/Constants.scss" as Constants;

.associated-subjob-data-container {
	display: flex;
	flex-direction: column;
	padding: Constants.$val-spacing-s;
	padding-left: Constants.$val-spacing-l;
}

.associated-subjob-data-header {
	text-transform: uppercase;
	font-size: Constants.$val-fontSizeRegular;
	color: Colors.$col-grey;
}

.associated-subjob-data-text {
	font-size: Constants.$val-fontSizeSmall;
	color: Colors.$col-grey;
}

.subjob-link {
	color: Colors.$col-blue;
	cursor: pointer;
	font-size: Constants.$val-fontSizeXBig;
}

.subjob-row {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
}

.subjob-row-column {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.link {
	display: flex;
	flex-direction: row;
	color: Colors.$col-blue;
	cursor: pointer;
	margin-bottom: Constants.$val-spacing-m;
	align-items: center;
}

.project-sub-job-indicator {
	margin-right: Constants.$val-spacing-s;
}

.originals-container {
	& > *  + * {
		margin-top: Constants.$val-spacing-s;
	}
}

.dropdown-option {
	width: max-content;
}

.overflow-text {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	min-width: 0;
}